/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    menuItem: {
      '&:hover': {
        backgroundColor: theme.palette.cardActive,
      },
    },
    listTitle: {
      color: theme.palette.titleText,
    },
    icon: {
      color: theme.palette.titleText,
    },
  };
});

export default function CustomMenu({ anchorEl, item, onClose, entries }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const renderEntries = () => {
    let components;
    if (entries && entries.length > 0) {
      components = entries.map((entry, index) => {
        return (
          /* Temporal workaround for fixing position of tooltip, until Design System tooltip implemented */
          <Tooltip
            key={index}
            title={entry.tooltipText ?? ''}
            disableHoverListener={!entry.disabled}
            PopperProps={{ placement: 'top-start', modifiers: { offset: { enabled: true, offset: '-50, -50' } } }}
          >
            <>
              <MenuItem
                className={classes.menuItem}
                id={entry.text}
                aria-label={`action-${entry.text}`}
                disabled={entry.disabled}
                onClick={() => entry.onClick(item)}
              >
                <ListItemIcon className={classes.listTitle}>
                  {{
                    ...entry.icon,
                    props: { ...entry.icon?.props, fontSize: 'small' },
                  }}
                </ListItemIcon>
                <ListItemText className={classes.icon} primary={t(entry.text)} />
              </MenuItem>
            </>
          </Tooltip>
        );
      });
    }
    return components;
  };

  return entries?.length ? (
    <Menu
      id="view-menu"
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      {renderEntries()}
    </Menu>
  ) : null;
}
